import { GET_YOUTUBE_CHANNELS_ANALYTICS_SUCCESS, GET_YOUTUBE_CHANNELS_ANALYTICS_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { channels: [], errors: null };

export default function ytChannelsAnalytics(state=INITIAL_STATE, action) {
  switch(action.type) {
    case GET_YOUTUBE_CHANNELS_ANALYTICS_SUCCESS:
    return { ...state, channels: action.payload, errors: null }
    case GET_YOUTUBE_CHANNELS_ANALYTICS_FAILURE:
      return { ...state, channels: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
